import { AnticipatedMonthlyActivityFormData } from '../../../types/forms'
import { OnboardingFormState } from '../../../types/state'
import { getSelectedCompany } from './getSelectedCompany'
import { setNewCompanies } from './setNewCompanies'

export const anticipatedMonthlyActivityToState = ({
  companyIndex,
  currentState,
  formData
}: {
  companyIndex: number
  currentState: OnboardingFormState
  formData: AnticipatedMonthlyActivityFormData
}) => {
  const oldCompany = getSelectedCompany({ companyIndex, currentState })

  // change ref in list
  const newCompaniesFormValues = setNewCompanies({
    companyIndex,
    oldCompanies: currentState.formValue.companiesFormValues,
    newCompany: { ...oldCompany, anticipatedMonthlyActivity: { ...formData } }
  })

  return {
    formValue: {
      ...currentState.formValue,
      companiesFormValues: newCompaniesFormValues
    }
  }
}
